import React, { useEffect, useState } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { editRegistry } from "../../../utils/api/editRegistry";
import { useAuthContext } from "../../../context/AuthContext";
import toast from "react-hot-toast";

const EditRegistry = ({ open, onCancel, reg, onOk }) => {
  const [registryName, setRegistryName] = useState("");
  const [registryId, setRegistryId] = useState("");
  //   const [shortName, setShortName] = useState("");
  const [userName, setUserName] = useState("");
  const [ID, setID] = useState("");
  //   const [registryImage, setRegistryImage] = useState("");
  //   const [data, setData] = useState(null);
  const [id, setId] = useState("");
  const { setAuthUser } = useAuthContext();

  useEffect(() => {
    setRegistryName(reg.registryName);
    setRegistryId(reg.registryID);
    setUserName(reg.registryUserName);
    // setShortName(reg.shortName);
    setID(reg.ID);
    // setRegistryImage(reg.image);
    setId(reg._id);
  }, [open]);

  const handleChangeRegistryName = (e) => {
    const name = e.target.value;
    setRegistryName(name);
  };

  const handleChangeId = (e) => {
    const id = e.target.value;
    setRegistryId(id);
  };

  const handleChangeUserName = (e) => {
    const userName = e.target.value;
    setUserName(userName);
  };

  const handleOnSubmit = async () => {
    const submissionData = {
      //   registryName: registryName,
      registryID: registryId,
      ID: ID,
      //   image: registryImage,
      //   shortName: shortName,
      registryUserName: userName,
    };
    try {
      await editRegistry({ id, info: submissionData }, setAuthUser);
      toast.success("Registry edited successfully");
      onOk();
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };

  const handleCancel = () => {
    setId("");
    setRegistryName("");
    setUserName("");
    setRegistryId("");
    onCancel();
  };

  return (
    <div>
      <DiaglogBox open={open} width={600} onCancel={onCancel}>
        <div className="px-14 text-3xl font-semibold py-5">Edit Registry</div>
        <hr className="border-b-2 border-gray-400" />
        <div className="flex justify-between py-4 mx-14 gap-0">
          <div>
            <label htmlFor="" className="pl-1 text-lg font-semibold">
              Registry Name
            </label>
            <br />
            <input
              type="text"
              value={registryName}
              className=" border-2 px-2 border-gray-400 rounded-lg w-48 mt-2"
              onChange={(e) => handleChangeRegistryName(e)}
              disabled={true}
            />
          </div>
          <div>
            <label htmlFor="" className="pl-1 text-lg font-semibold">
              ID
            </label>
            <br />
            <input
              type="text"
              value={registryId}
              className=" border-b-2 px-2 border-gray-300  w-60 mt-2"
              onChange={(e) => handleChangeId(e)}
            />
          </div>
        </div>
        <div className="mx-14">
          <label htmlFor="" className="pl-1 text-lg font-semibold">
            UserName
          </label>
          <br />
          <input
            type="text"
            value={userName}
            className=" border-b-2 px-2 border-gray-300  w-48 mt-2"
            onChange={(e) => handleChangeUserName(e)}
          />
        </div>
        <div className="flex justify-center py-4 gap-6">
          <Button
            color={"blue"}
            varient={"secondary"}
            className={"text-white  w-60 py-2 text-xl font-semibold"}
            onClick={handleOnSubmit}
          >
            Submit
          </Button>
          <Button
            color={"lightblue"}
            varient={"secondary"}
            className={" text-blue-800 w-60 py-2 text-xl font-semibold"}
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default EditRegistry;
